const { asCiteprocItem } = require('@readcube/readcube-citeproc')
const CSL                = require('citeproc')
const { enUs }           = require('./locale')

const genMultiItem = (opts) => {

  const { style } = opts
  opts.locale = opts.locale || enUs

  const itemAsCslItem = item => {
    const cslItem = asCiteprocItem({ item, customSchema: opts.mapping, customFields: opts.customFields })
    cslItem.id = item.id
    return cslItem
  }

  const cslItems =
    opts.cslItems
    || (opts.items && opts.items.map(itemAsCslItem))

  cslItems
    .forEach((cslItem, index) => {
      if (!cslItem.id)
        cslItem.id = 'citation-gen-id-' + index
    })

  const sys = {
    retrieveItem  : ref => cslItems.find(cslItem => cslItem.id === ref),
    retrieveLocale: () => opts.locale,
  }

  const citeprocEngine = new CSL.Engine(sys, style)
  citeprocEngine.updateItems(cslItems.map(cslItem => cslItem.id))
  citeprocEngine.setOutputFormat(opts.outputFormat || 'html')

  const biblio = citeprocEngine.makeBibliography()

  const citationsPre = {}
  const citationEntries =
    cslItems
      .map(cslItem => {

        const citation = {
          properties: { nodeIndex: 0 },
          citationItems: [cslItem],
        }

        const processClusterResult =
          citeprocEngine
            .processCitationCluster(citation, Object.entries(citationsPre), [])

        const citationResult =
          processClusterResult
          && processClusterResult[1]
          && ({
            text: processClusterResult[1][0][1],
            id: processClusterResult[1][0][2],
          })

        if (!citationResult)
          return

        if (!citationsPre[citationResult.id])
          citationsPre[citationResult.id] = 0

        return citationResult.text
      })

  const bibliographyEntry =
      biblio
      && biblio[1]
      && biblio[1].join("").trim()

  return { citationEntries, bibliographyEntry }
}

exports.gen = (opts) => {

  let multiGenOpts = {...opts}
  if (opts.item)
    multiGenOpts.items = [opts.item]

  if (opts.cslItem)
    multiGenOpts.cslItems = [opts.cslItem]

  const { citationEntries, bibliographyEntry } = genMultiItem(multiGenOpts)

  return opts.items || opts.cslItems
    ? { citationEntries, bibliographyEntry }
    : { citationEntry: citationEntries[0], bibliographyEntry }
}